import React, { useEffect, useState } from "react";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const normalizeBranchName = (name = "") => {
    return name
        .toLowerCase()
        .replace(/[0-9]/g, "")        // remove numbers
        .replace(/[^a-z\s]/g, "")    // remove symbols
        .replace(/\s+/g, " ")        // normalize spaces
        .trim();
};


const Edit_CheckZMCMConveyance = () => {
    const { id, month } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken");
    const [othersCount, setOthersCount] = useState(0);
    const [profile, setProfile] = useState(null);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [auditStatus, setAuditStatus] = useState("PENDING");
    const [auditRemarks, setAuditRemarks] = useState("");
    const [accountStatus, setAccountStatus] = useState("");
    const [audit_approved_date, setAuditApprovedDate] = useState("");
    const [account_approved_date, setAccountApprovedDate] = useState("");
    const [accountRemarks, setAccountRemarks] = useState("");
    const [filterDate, setFilterDate] = useState("");
    const [details, setDetails] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState("");
    const [visitRows, setVisitRows] = useState([]);
    const [message, setMessage] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [filterBranch, setFilterBranch] = useState("");
    const [filterDevice, setFilterDevice] = useState("");

    const handleAddOthers = () => {
        const key = `OTHERS_${othersCount}`;

        setRows(prev => [
            ...prev,
            {
                id: null,
                Punch_date: "",
                Branch: "Others",
                Device: null,
                PunchTimes: "",
                from: "",
                to: "",
                remarks: "",
                reason: "",
                entryType: "others",
                attachment: null,
                newAttachment: null,
                _tempKey: key   // 🔑 for unique identification
            }
        ]);

        setOthersCount(prev => prev + 1);
    };

    const handleRemoveOthers = (row) => {
        // ❌ block deleting DB rows
        if (row.id) {
            toast.warning("Saved rows cannot be removed");
            return;
        }

        setRows(prev =>
            prev.filter(r =>
                r !== row
            )
        );
    };
    /* ================= PROFILE ================= */
    useEffect(() => {
        fetch(`${API_BASE_URL}profile`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(d => {
                if (d.status && d.profile) {
                    setProfile(d.profile);

                    // ✅ CALL fetchDetails here
                    fetchDetails(d.profile.emp_code);
                }
            })
            .catch(err => {
                console.error("Failed to load profile", err);
            });
    }, []);

    const fetchDetails = async (empCode) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}getcmzmdetails/${empCode}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            const result = await response.json();

            if (result.status && result.data.status === "success") {
                const row = result.data.data[0];
                setDetails([row]);

                const branchArray = row.branches_list || [];
                const role = row.role;

                // 🔹 Decide visits per branch based on role
                const visitsPerBranch =
                    role === "cluster_manager" ? 2 : 1;

                // 🔹 Total visits
                const totalVisits = branchArray.length * visitsPerBranch;

                // 🔹 Amount split
                const totalAmount = parseFloat(row.amount);
                setTotalAmount(totalAmount);
                const perVisitAmount = totalAmount / totalVisits;
                const displayAmount = Number(perVisitAmount).toFixed(2);
                const visits = [];

                branchArray.forEach((b) => {
                    for (let visitNo = 1; visitNo <= visitsPerBranch; visitNo++) {
                        visits.push({
                            visit_no: visitNo,
                            branch_id: b.id,
                            branch_name: b.name,
                            date: "",
                            from_time: "",
                            to_time: "",
                            day: "",
                            purpose: "",
                            remarks: "",
                            amount: 0,
                            attachment: null,
                        });
                    }
                });

                setVisitRows(visits);
            } else {
                setMessage(result.data?.message || "No conveyance records found");
            }
        } catch (err) {
            setMessage("Failed to load conveyance details");
        } finally {
            setLoading(false);
        }
    };




    /* ================= LOAD DATA ================= */
    useEffect(() => {
        loadPunches();
    }, [month]);

    const loadPunches = async () => {
        try {
            const [punchRes, editedRes] = await Promise.all([
                fetch(`https://travelapp.vdcapp.in/backend/api/get_punches_for_user`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ selected_month: month })
                }),
                fetch(`${API_BASE_URL}get_punch_times`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ id, month })
                })
            ]);

            const punchData = await punchRes.json();
            const editedData = await editedRes.json();

            if (editedData?.data?.length > 0) {
                setIsSubmitted(editedData.data[0].is_submitted);
            } else {
                setIsSubmitted("N");
            }

            if (editedData?.data?.length > 0) {
                setAuditStatus(editedData.data[0].audit_status || "Pending");
                setAuditRemarks(editedData.data[0].audit_remarks || "");
                setAuditApprovedDate(editedData.data[0].audit_approved_date || "");

                setAccountStatus(editedData.data[0].account_status || "Pending");
                setAccountRemarks(editedData.data[0].account_remarks || "");
                setAccountApprovedDate(editedData.data[0].account_approved_date || "");
            }

            const editedMap = {};
            if (editedData?.status && Array.isArray(editedData.data)) {
                editedData.data.forEach(r => {
                    editedMap[`${r.Device}_${r.Punch_date}`] = r;
                });
            }

            const merged = [];

            editedData?.data?.forEach(r => {
                merged.push({
                    id: r.id,
                    Punch_date: r.Punch_date,
                    Branch: r.Branch,
                    Device: r.Device,
                    PunchTimes: r.PunchTimes,
                    from: r.From_Time ? r.From_Time.substring(0, 5) : "",
                    to: r.To_Time ? r.To_Time.substring(0, 5) : "",
                    remarks: r.Remarks || "",
                    reason: r.Reason_For_Others || "",   // ✅ IMPORTANT
                    entryType: r.EntryType || "punch",   // ✅ IMPORTANT
                    attachment: r.attachment || null
                });
            });

            punchData?.data?.forEach(p => {
                const key = `${p.DeviceId}_${p.LogDate}`;
                if (!editedMap[key]) {
                    merged.push({
                        id: null,
                        Punch_date: p.LogDate,
                        Branch: p.DeviceFNAME,
                        Device: p.DeviceId,
                        PunchTimes: p.PunchTimes,
                        from: "",
                        to: "",
                        remarks: ""
                    });
                }
            });
            merged.sort((a, b) => {
                if (!a.Punch_date) return 1;
                if (!b.Punch_date) return -1;

                return new Date(a.Punch_date) - new Date(b.Punch_date);
            });
            setRows(merged);
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };

    const updateField = (row, field, value) => {
        setRows(prev =>
            prev.map(r =>
                (r === row || (r.id && r.id === row.id))
                    ? { ...r, [field]: value }
                    : r
            )
        );
    };

    const calcDuration = (f, t) => {
        if (!f || !t) return "";
        const [fh, fm] = f.split(":").map(Number);
        const [th, tm] = t.split(":").map(Number);
        const diff = (th * 60 + tm) - (fh * 60 + fm);
        return diff > 0 ? `${Math.floor(diff / 60)}h ${diff % 60}m` : "";
    };

    const handleSave = async (type = "draft") => {

        /* ================= VALIDATION ================= */
        for (const r of rows) {
            if (!r.from && !r.to && !r.remarks && !r.newAttachment) continue;

            if (!r.Punch_date) {
                toast.error("Date is required");
                return;
            }

            if (!r.Branch) {
                toast.error("Branch is required");
                return;
            }

            if (!r.from || !r.to) {
                toast.error("From time and To time are required");
                return;
            }

            // if (r.entryType === "others" && !r.reason) {
            //     toast.error("Reason is required for Others");
            //     return;
            // }
        }

        /* ================= BUILD PAYLOAD ================= */
        const punches = [];
        const attachmentsMap = {};

        rows.forEach((r) => {
            if (!r.from && !r.to && !r.remarks && !r.newAttachment) return;

            const punchIndex = punches.length;

            punches.push({
                index: punchIndex,
                id: r.id || null,
                details_id: id,
                date: r.Punch_date,
                branch: r.Branch,
                device: r.entryType === "others" ? null : r.Device,
                punch_times: r.PunchTimes || "",
                from: r.from,
                to: r.to,
                duration: calcDuration(r.from, r.to),
                remarks: r.remarks || null,
                reason: r.entryType === "others" ? r.reason || null : null,
                entry_type: r.entryType || "punch",
            });

            if (r.newAttachment) {
                attachmentsMap[punchIndex] = r.newAttachment;
            }
        });

        if (punches.length === 0) {
            toast.warning("No changes to save");
            return;
        }

        /* ================= SUBMIT CONFIRM ================= */
        if (type === "submit") {
            const confirmSubmit = window.confirm(
                "Once submitted, you will not be able to edit this data. Continue?"
            );
            if (!confirmSubmit) return;
        }

        /* ================= FORM DATA ================= */
        const formData = new FormData();
        formData.append("id", id);
        formData.append("is_submitted", type === "submit" ? "Y" : "N");
        formData.append("punches", JSON.stringify(punches));

        Object.keys(attachmentsMap).forEach((idx) => {
            formData.append(`attachment_${idx}`, attachmentsMap[idx]);
        });

        try {
            const res = await fetch(`${API_BASE_URL}update_punch_times`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`
                },
                body: formData
            });

            const result = await res.json();

            if (result.status) {

                if (type === "submit") {
                    toast.success("Submitted successfully");   // 🚀 unchanged
                    setTimeout(() => navigate("/manage_checkcmzmconveyance"), 800);
                } else {
                    toast.success("Successfully updated");     // 💾 draft case
                    setTimeout(() => navigate("/manage_checkcmzmconveyance"), 800);
                }

            } else {
                toast.error(result.message || "Failed to save");
            }

        } catch (error) {
            console.error(error);
            toast.error("Server error. Please try again.");
        }
    };



    if (loading) return <h3 style={{ padding: 20 }}>Loading...</h3>;

    const topSectionBranches =
        details[0]?.branches_list?.map(b => ({
            original: b.name,
            normalized: normalizeBranchName(b.name)
        })) || [];

    // ✅ Visit counter (resets every render – correct behavior)
    const branchVisitCounter = {};

    // ✅ COUNT V1 & V2 VISITS
    const visitsPerBranch =
        details[0]?.role === "cluster_manager" ? 2 : 1;

    const branchCounter = {};

    let v1Count = 0;
    let v2Count = 0;

    rows.forEach(row => {

        // ignore Others rows
        if (row.entryType === "others") return;

        const branchName = row.Branch || "";
        const normalizedPunchBranch = normalizeBranchName(branchName);

        const matchedTopBranch = topSectionBranches.find(tb =>
            normalizedPunchBranch.includes(tb.normalized)
        );

        if (!matchedTopBranch) return;

        const key = matchedTopBranch.normalized;

        // visit increment
        branchCounter[key] = (branchCounter[key] || 0) + 1;

        if (branchCounter[key] === 1) v1Count++;
        if (branchCounter[key] === 2) v2Count++;
    });

    // ✅ FINAL TOTAL
    const totalVisits = v1Count + v2Count;

    const perVisitAmount =
        totalVisits > 0
            ? (totalAmount / totalVisits).toFixed(2)
            : 0;

    console.log("V1 =", v1Count);
    console.log("V2 =", v2Count);
    console.log("TOTAL =", totalVisits);

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ background: "#f4f7fb", fontSize: '12px' }}>
            <Header />
            <Sidebar />

            <div className="content-wrapper" style={{ padding: "25px" }}>

                <h2 style={{
                    color: "#6ca0dc",
                    fontWeight: "800",
                    fontSize: "24px",
                    marginBottom: "12px"
                }}>
                    Fixed Conveyance
                </h2>

                {/* EMPLOYEE INFO */}
                {profile && details.length > 0 && (
                    <div
                        style={{
                            background: "#ffffffee",
                            padding: "18px 22px",
                            borderRadius: "12px",
                            border: "1px solid #d9e3f1",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                            marginBottom: "25px"
                        }}
                    >
                        {details.map((row, idx) => (
                            <div key={idx}>
                                {/* ===== Top Row ===== */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: "30px",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                        borderBottom: "1px dashed #dbe3ef",
                                        fontSize: "14px",
                                        color: "#425b70",
                                    }}
                                >
                                    <span>
                                        <b>Employee:</b> {profile.comp_name} ({profile.emp_code})
                                    </span>

                                    <span>
                                        <b>Selected Month:</b> {month}
                                    </span>

                                    <span>
                                        <b>Role:</b> {row.role}
                                    </span>

                                    <span>
                                        <b>Total Branches:</b> {row["1_30_cnt"]}
                                    </span>

                                    <span>
                                        <b>Amount:</b> {row["amount"]}
                                    </span>
                                </div>

                                {/* ===== Branches Row ===== */}
                                <div
                                    style={{
                                        fontSize: "14px",
                                        color: "#425b70",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    <b>Branches:</b>{" "}
                                    {row.branches_list && row.branches_list.length > 0
                                        ? row.branches_list
                                            .slice() // avoid mutating original array
                                            .sort((a, b) => a.name.localeCompare(b.name)) // 🔤 alphabetical sort
                                            .map(b => b.name)
                                            .join(", ")
                                        : "N/A"}
                                </div>
                            </div>
                        ))}
                    </div>
                )}


                {/* TABLE CARD */}
                <div style={cardStyle}>
                    <div style={{ ...tableScrollWrapper, padding: "10px" }}>


                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Date</th>
                                    <th style={thStyle}>Branch</th>
                                    {/* <th style={thStyle}>Device</th> */}
                                    <th style={thStyle}>Punch Times</th>
                                    <th style={thStyle}>From</th>
                                    <th style={thStyle}>To</th>
                                    <th style={thStyle}>Duration</th>
                                    <th style={thStyle}>Amount</th>
                                    <th style={thStyle}>Remarks</th>
                                    <th style={thStyle}>Reason</th>
                                    <th style={thStyle}>Attachment</th>
                                    <th style={thStyle}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row, i) => (
                                    <tr key={i} style={{ background: i % 2 === 0 ? "#fafafa" : "#fff" }}>
                                        <td style={tdStyle}>
                                            <input
                                                type="date"
                                                style={inputStyle}
                                                value={row.Punch_date || ""}
                                                max={new Date().toISOString().split("T")[0]}   // 👈 blocks future dates
                                                onChange={(e) => updateField(row, "Punch_date", e.target.value)}
                                            />
                                        </td>


                                        <td style={tdStyle}>
                                            {row.entryType === "others" && !row.id ? (
                                                /* ✅ Branch dropdown ONLY for newly added Others rows */
                                                <select
                                                    style={selectStyle}
                                                    value={row.Branch || ""}
                                                    onChange={(e) => updateField(row, "Branch", e.target.value)}
                                                >
                                                    <option value="">Select Branch</option>

                                                    {[...new Set(
                                                        rows
                                                            .map(r => r.Branch)
                                                            .filter(b => b && b !== "Others")
                                                    )].map((branch, idx) => (
                                                        <option key={idx} value={branch}>
                                                            {branch}
                                                        </option>
                                                    ))}

                                                    {/* 🔹 Others as LAST option */}
                                                    <option value="Others">Others</option>
                                                </select>
                                            ) : (
                                                (() => {
                                                    const branchName = row.Branch || "";

                                                    // ❌ Others rows → no V1/V2
                                                    if (row.entryType === "others") {
                                                        return (
                                                            <span style={{ fontWeight: "600", color: "#374151" }}>
                                                                {branchName}
                                                            </span>
                                                        );
                                                    }

                                                    const normalizedPunchBranch = normalizeBranchName(branchName);

                                                    const matchedTopBranch = topSectionBranches.find(tb =>
                                                        normalizedPunchBranch.includes(tb.normalized)
                                                    );

                                                    if (matchedTopBranch) {
                                                        // ✅ Use EXACT branch name for visit count
                                                        const key = branchName;

                                                        if (!branchVisitCounter[key]) {
                                                            branchVisitCounter[key] = 1;
                                                        } else {
                                                            branchVisitCounter[key] += 1;
                                                        }

                                                        const visitLabel = `V${branchVisitCounter[key]}`;

                                                        return (
                                                            <span style={{ fontWeight: "600", color: "#374151" }}>
                                                                {branchName}{" "}
                                                                <span
                                                                    style={{
                                                                        background: "#e0edff",
                                                                        color: "#2563eb",
                                                                        padding: "2px 6px",
                                                                        borderRadius: "6px",
                                                                        fontSize: "11px",
                                                                        fontWeight: "700",
                                                                        marginLeft: "4px"
                                                                    }}
                                                                >
                                                                    {visitLabel}
                                                                </span>
                                                            </span>
                                                        );
                                                    }

                                                    return (
                                                        <span style={{ fontWeight: "600", color: "#374151" }}>
                                                            {branchName}
                                                        </span>
                                                    );
                                                })()

                                            )}
                                        </td>







                                        {/* <td style={tdStyle}>{row.Device}</td> */}
                                        <td style={tdStyle}>
                                            {row.PunchTimes && row.PunchTimes.trim() !== "" ? row.PunchTimes : "No"}
                                        </td>
                                        <td style={tdStyle}>
                                            {row.entryType === "others" ? (
                                                <input
                                                    type="time"
                                                    style={inputStyle}
                                                    value={row.from || ""}
                                                    onChange={(e) => updateField(row, "from", e.target.value)}
                                                />
                                            ) : (
                                                <select
                                                    style={selectStyle}
                                                    value={row.from}
                                                    onChange={(e) => updateField(row, "from", e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {row.PunchTimes?.split(",").map(p => (
                                                        <option key={p} value={p.trim()}>{p.trim()}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </td>

                                        <td style={tdStyle}>
                                            {row.entryType === "others" ? (
                                                <input
                                                    type="time"
                                                    style={inputStyle}
                                                    value={row.to || ""}
                                                    onChange={(e) => updateField(row, "to", e.target.value)}
                                                />
                                            ) : (
                                                <select
                                                    style={selectStyle}
                                                    value={row.to}
                                                    onChange={(e) => updateField(row, "to", e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {row.PunchTimes?.split(",").map(p => (
                                                        <option key={p} value={p.trim()}>{p.trim()}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </td>

                                        <td style={tdStyle}>{calcDuration(row.from, row.to)}</td>
                                        <td style={tdStyle}>
                                            {
                                                (() => {

                                                    if (row.entryType === "others") return "-";

                                                    const branchName = row.Branch || "";
                                                    const normalizedPunchBranch = normalizeBranchName(branchName);

                                                    const matchedTopBranch = topSectionBranches.find(tb =>
                                                        normalizedPunchBranch.includes(tb.normalized)
                                                    );

                                                    if (!matchedTopBranch) return "-";

                                                    const key = branchName;

                                                    // current visit number (already calculated in UI)
                                                    const visitNo = branchVisitCounter[key];

                                                    // ✅ show only V1 & V2
                                                    if (visitNo === 1 || visitNo === 2) {
                                                        return perVisitAmount;
                                                    }

                                                    return "-";
                                                })()
                                            }
                                        </td>
                                        <td style={tdStyle}>
                                            <textarea
                                                style={{ ...inputStyle, resize: "none" }}
                                                rows={1}
                                                value={row.remarks || ""}
                                                onChange={(e) => updateField(row, "remarks", e.target.value)}
                                            />
                                        </td>
                                        <td style={tdStyle}>
                                            {row.Branch === "Others" ? (
                                                <textarea
                                                    style={{ ...inputStyle, resize: "none" }}
                                                    rows={1}
                                                    placeholder="Enter reason"
                                                    value={row.reason || ""}
                                                    onChange={(e) => updateField(row, "reason", e.target.value)}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td style={tdStyle}>
                                            {row.attachment && (
                                                <div style={{ marginBottom: "4px" }}>
                                                    <a
                                                        href={`${API_BASE_URL.replace("/api/", "")}/uploads/punch_attachments/${row.attachment}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "#2563eb", fontWeight: "600" }}
                                                    >
                                                        📎 View
                                                    </a>
                                                </div>
                                            )}

                                            <input
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                onChange={(e) =>
                                                    updateField(row, "newAttachment", e.target.files[0])
                                                }
                                            />
                                        </td>

                                        <td style={tdStyle}>
                                            {row.entryType === "others" && !row.id && (
                                                <button
                                                    onClick={() => handleRemoveOthers(row)}
                                                    style={{
                                                        width: "28px",
                                                        height: "28px",
                                                        borderRadius: "50%",
                                                        background: "#ef4444",
                                                        color: "#fff",
                                                        border: "none",
                                                        cursor: "pointer",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                        lineHeight: "27px",
                                                        textAlign: "center",
                                                        padding: "0"
                                                    }}
                                                    title="Remove"
                                                >
                                                    –
                                                </button>
                                            )}
                                        </td>



                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ===== AUDIT & ACCOUNT STATUS SUMMARY ===== */}
                <div
                    style={{
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: "12px",
                        padding: "14px 18px",
                        marginTop: "20px",
                        marginBottom: "10px",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                        fontSize: "14px",
                        color: "#334155"
                    }}
                >
                    {/* Audit Box */}
                    <div
                        style={{
                            background: "#ffffff",
                            border: "1px solid #dbeafe",
                            borderRadius: "10px",
                            padding: "12px 14px"
                        }}
                    >
                        <div style={{ fontWeight: "700", marginBottom: "6px", color: "#1e40af" }}>
                            🛂 Audit Status
                        </div>
                        <div><b>Status:</b> {auditStatus || "Pending"}</div>
                        <div style={{ marginTop: "4px" }}>
                            <b>Remarks:</b>{" "}
                            <span style={{ color: "#475569" }}>
                                {auditRemarks || "—"}
                            </span>
                        </div>
                        <div><b>Audit Approved Date:</b> {audit_approved_date || ""}</div>
                    </div>

                    {/* Account Box */}
                    <div
                        style={{
                            background: "#ffffff",
                            border: "1px solid #dcfce7",
                            borderRadius: "10px",
                            padding: "12px 14px"
                        }}
                    >
                        <div style={{ fontWeight: "700", marginBottom: "6px", color: "#065f46" }}>
                            💰 Finance Status
                        </div>
                        <div><b>Status:</b> {accountStatus || "Pending"}</div>
                        <div style={{ marginTop: "4px" }}>
                            <b>Remarks:</b>{" "}
                            <span style={{ color: "#475569" }}>
                                {accountRemarks || "—"}
                            </span>
                        </div>
                        <div><b>Account Approved Date:</b> {account_approved_date || ""}</div>
                    </div>
                </div>



                <div style={{ textAlign: "right", marginTop: "12px" }}>
                    <button
                        onClick={handleAddOthers}
                        style={{
                            background: "#f59e0b",
                            color: "#fff",
                            padding: "8px 18px",
                            borderRadius: "8px",
                            border: "none",
                            fontWeight: "700",
                            cursor: "pointer"
                        }}
                    >
                        ➕ Add Others
                    </button>
                </div>
                {/* ACTION BUTTONS */}
                <div style={actionBar}>
                    <button onClick={() => navigate("/manage_checkcmzmconveyance")} style={{ ...buttonBase, background: "#6b7280" }}>
                        ❌ Cancel
                    </button>
                    {isSubmitted !== "Y" && (
                        <>
                            <button onClick={() => handleSave("draft")} style={{ ...buttonBase, background: "#2563eb" }}>
                                💾 Save as Draft
                            </button>
                            <button onClick={() => handleSave("submit")} style={{ ...buttonBase, background: "#16a34a" }}>
                                🚀 Send for Approval
                            </button>
                        </>
                    )}

                </div>
            </div>

            <Footer />.
            <ToastContainer />
        </div>
    );
};

/* ================= STYLES ================= */

const tableScrollWrapper = {
    maxHeight: "60vh",      // controls scroll height
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "10px"
};


const profileBox = {
    background: "#ffffff",
    padding: "15px 20px",
    borderRadius: "12px",
    marginBottom: "20px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
};

const cardStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px"
};

const thStyle = {
    padding: "10px",
    background: "#f8fafc",
    borderBottom: "2px solid #e5e7eb",
    fontWeight: 600
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "13px"
};

const inputStyle = {
    width: "100%",
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #cbd5e1"
};

const selectStyle = {
    ...inputStyle,
    cursor: "pointer"
};

const buttonBase = {
    padding: "12px 36px",
    fontSize: "15px",
    borderRadius: "10px",
    border: "none",
    fontWeight: "700",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
};

const actionBar = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "25px"
};

export default Edit_CheckZMCMConveyance;
